<template>
  <div class="notifications-list">
    <Notification-message
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
    />
  </div>
</template>

<script>
// import NotificationMessage from './NotificationMessage.vue'
import { mapState } from 'vuex'
export default {
  // components: {
  //   NotificationMessage
  // },
  computed: mapState(['notifications'])
}
</script>

<style>
.notifications-list {
  position: fixed;
  bottom: 1rem;
  right: 0;
  margin-right: 15px;
  width: 300px;
}
</style>
